(()=>{
const root=document.querySelector('[data-pp]');if(!root)return;
// gallery thumbs <-> slides
const slides=root.querySelector('[data-slides]');
if(slides){const th=[...root.querySelectorAll('.pp-thumbs button')];
  th.forEach((b,i)=>b.addEventListener('click',()=>{slides.scrollTo({left:slides.clientWidth*i,behavior:'smooth'})}));
  slides.addEventListener('scroll',()=>{const i=Math.round(slides.scrollLeft/slides.clientWidth);th.forEach((b,j)=>b.setAttribute('aria-selected',String(i===j)))},{passive:true});}
// offer price swap
const form=root.querySelector('[data-form]');
if(form){const set=r=>{for(const k of ['price','compare','save']){const el=root.querySelector('[data-'+k+']:not(input)');if(el)el.textContent=r.dataset[k]}
  const sp=root.querySelector('[data-sticky-price]');if(sp)sp.textContent=r.dataset.price};
  form.querySelectorAll('input[name=id]').forEach(r=>r.addEventListener('change',()=>set(r)));}
// sticky bar after the buy box leaves view (mobile)
const st=root.querySelector('[data-sticky]'),buy=root.querySelector('#pp-buy .pp-cta');
if(st&&buy&&'IntersectionObserver' in window){new IntersectionObserver(([e])=>{st.hidden=e.isIntersecting||e.boundingClientRect.top>0}).observe(buy)}
// cart upsell: swap a single Buy 1 line for Buy 2
const up=root.querySelector('[data-upgrade]');
if(up){up.addEventListener('click',async()=>{up.disabled=true;
  try{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+up.dataset.line,quantity:0})});
  await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+up.dataset.to,quantity:1}]})});}
  finally{location.reload()}})}
// pause offscreen loops
if('IntersectionObserver' in window){const io=new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;if(e.isIntersecting){v.play&&v.play().catch(()=>{})}else{v.pause()}}),{rootMargin:'200px'});
  root.querySelectorAll('video.pp-loop').forEach(v=>io.observe(v))}
})();
